import React, { createContext, Dispatch, useState } from "react"

interface IBackgroundColourState {
  dark: boolean
}

interface IBackgroundColourContext {
  state: IBackgroundColourState
  dispatch: Dispatch<React.SetStateAction<IBackgroundColourState>>
}

export const BackgroundColourContext = createContext({
  state: { dark: false },
} as IBackgroundColourContext)

/** List of dark background colours to search.
 * If the provided background is included in this list, then we need to enable light text for contrast.  */
const darkColours = ["var(--tricorn-black)", "#282828"]

export const isDarkColour = (colour?: string) =>
  darkColours.includes(colour || "")

/**
 * A theme context for sections with background colour.
 * Wraps children in a div with background colour and sets a dark mode state.
 */
export const BackgroundColourContextProvider = ({
  children,
  colour,
}: {
  children: React.ReactNode | React.ReactNode[]
  colour?: string
}) => {
  const [state, dispatch] = useState<IBackgroundColourState>({
    dark: isDarkColour(colour),
  })
  return (
    <BackgroundColourContext.Provider value={{ state, dispatch }}>
      {colour ? (
        <div style={{ backgroundColor: colour }}>{children}</div>
      ) : (
        children
      )}
    </BackgroundColourContext.Provider>
  )
}
